<!--content single product-->
<div class="container py-5 px-lg-0" *ngIf="accessorio">
	<div class="my-5">
		<div class="text-center">
			<h1 class="titolo-bertazzoni">{{getDescrizione(accessorio).valore}}</h1>
			<h5>
				{{accessorio.selected.codiceCommerciale}}
				<ng-container *soloUsa>
					<p *ngIf="accessorio.selected.giacenzaMagazzino > 0" class="font-14 mb-0 font-semibold text-success">
						{{accessorio.selected.giacenzaMagazzino}} items available
					</p>
					<p *ngIf="accessorio.selected.giacenzaMagazzino === 0" class="font-14 mb-0 font-semibold text-secondary">Unavailable</p>
				</ng-container>
				<ng-container *nonUsa>
					<p class="font-14 mb-0 font-semibold" style="color: red;" *ngIf="accessorio.selected.statoGiacenza === 'IN_STOCK'">
						Product in phase-Out: {{accessorio.selected.giacenza}} pcs. In Stock
					</p>
				</ng-container>
			</h5>
		</div>
	</div>
	<div class="row">
		<div class="col-md-6 col-12 text-center">
			<img *ngIf="accessorio.selected.immagini.length > 0" [src]="accessorio.selected.immagini[0]?.path | img" />
			<img *ngIf="accessorio.selected.immagini.length == 0" [src]="'assets/img/no-img.png'" />
		</div>
		<div class="col-md-2 col-8 mt-5 mx-auto d-flex d-md-block text-right justify-content-around align-items-center">
			<div
				class="d-flex justify-content-end mb-3 mt-lg-5"
				(click)="accessorio.selected = commerciale"
				*ngFor="let commerciale of accessorio.prodottiCommerciali">
				<div class="font-16 mr-3" [class.d-none]="accessorio.selected != commerciale">{{commerciale.colore.idBertazzoni | translate}}</div>
				<span class="cerchietto" [style.background-color]="commerciale.colore.codiceHtml"></span>
			</div>
		</div>
		<div class="col-lg-4 col-md-5 mx-md-auto col-12 mt-5">
			<div class="ml-auto col-lg-8 px-0">
				<p class="font-14 mb-1 font-semibold" style="color: red;" *ngIf="accessorio.selected.statoGiacenza === 'IN_STOCK'">
					Product in phase-Out: {{accessorio.selected.giacenza}} pcs. In Stock
				</p>
				<div class="bg-grey-my py-3 text-center">
					<p class="mb-0 font-20 text-white">
						{{ '' | valuta }} {{accessorio.selected.listini[0].prezzoNetto * accessorio.selected.quantita | number}}
					</p>
				</div>
				<form #form="ngForm" *ngIf="accessorio.selected">
					<div class="">
						<div class="d-flex">
							<div class="number-input">
								<div (click)="stepQuantita('-')" class="selettore-spin"></div>
								<input
									class="quantity form-bertazzoni"
									min="0"
									max="100"
									name="quantity"
									value="1"
									type="number"
									[(ngModel)]="accessorio.selected.quantita"
									required />
								<div (click)="stepQuantita('+')" class="selettore-spin plus"></div>
							</div>
						</div>
						<button
							class="btn btn-bertazzoni black btn-block rounded-0"
							style="border-top-color: transparent; height: 35px;"
							(click)="buy()"
							[disabled]="form.invalid || accessorio.selected.quantita == 0">
							ADD TO CART
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</div>
